module.exports = __webpack_public_path__ + "static/media/md-done-all.0657748a.svg";